import { ref, reactive, markRaw } from 'vue'

// 전역 상태
const activeModals = ref({})
const modalComponents = reactive({})
const modalData = reactive({})
const eventCallbacks = reactive({})
let initialized = false

export const useModal = () => {
    // 모달 컴포넌트 자동 등록 초기화 (webpack용)
    const initializeModals = () => {
        if (initialized) return

        // webpack의 require.context를 사용한 자동 등록
        const requireComponent = require.context(
            '@/components/modals',
            false,
            /\.vue$/
        )

        requireComponent.keys().forEach(fileName => {
            const componentConfig = requireComponent(fileName)
            const component = componentConfig.default || componentConfig

            // 파일명에서 모달 이름 추출 (./UserModal.vue -> userModal)
            const modalName = fileName
                .split('/')
                .pop()
                ?.replace(/\.\w+$/, '')
                ?.replace(/^[A-Z]/, match => match.toLowerCase()) || ''

            // ModalManager는 제외
            if (modalName !== 'modalManager') {
                modalComponents[modalName] = markRaw(component)
            }
        })

        initialized = true
    }

    // 초기화 실행
    initializeModals()

    // 모달 열기
    const openModal = (modalName, props = {}) => {
        if (!modalComponents[modalName]) {
            return
        }

        activeModals.value[modalName] = {
            isOpen: true,
            component: modalComponents[modalName],
            props
        }
    }

    // 모달 닫기
    const closeModal = (modalName) => {
        Object.keys(activeModals.value).forEach(key => {
            activeModals.value[key].isOpen = false
        })
        // if (!modalName) {
        //     Object.keys(activeModals.value).forEach(key => {
        //         activeModals.value[key].isOpen = false
        //     })
        //     return
        // }

        // if (activeModals.value[modalName]) {
        //     activeModals.value[modalName].isOpen = false
        // }
    }

    // 활성화된 모달 목록
    const getActiveModals = () => {
        return Object.entries(activeModals.value)
            .filter(([_, modal]) => modal.isOpen)
            .map(([name, modal]) => ({
                name,
                component: modal.component,
                props: modal.props
            }))
    }

    // 모달 데이터 관리
    const setModalData = (modalName, data) => {
        modalData[modalName] = data
    }

    const getModalData = (modalName) => {
        return modalData[modalName]
    }

    // 이벤트 콜백 관리
    const onModalEvent = (modalName, event, callback) => {
        if (!eventCallbacks[modalName]) {
            eventCallbacks[modalName] = {}
        }
        eventCallbacks[modalName][event] = callback
    }

    const emitModalEvent = (modalName, event, data) => {
        const callback = eventCallbacks[modalName]?.[event]
        if (callback) {
            callback(data)
        }
    }

    // 데이터 저장 후 모달 닫기
    const saveAndClose = (modalName, data) => {
        if (data) {
            setModalData(modalName, data)
        }

        closeModal(modalName)
        emitModalEvent(modalName, 'onSubmit', data)
    }

    // 등록된 모달 목록 확인 (디버깅용)
    const getRegisteredModals = () => {
        return Object.keys(modalComponents)
    }

    return {
        openModal,
        closeModal,
        getActiveModals,
        setModalData,
        getModalData,
        onModalEvent,
        emitModalEvent,
        saveAndClose,
        getRegisteredModals
    }
}